import { useEffect, useState, useRef, RefObject } from 'react'

export default function useOnScreen<T extends RefObject<HTMLElement>>(ref: T): boolean {
  const observerRef = useRef<IntersectionObserver | null>(null)
  const [isOnScreen, setIsOnScreen] = useState(true)

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsOnScreen(true)
        } else if (entry.boundingClientRect.top < 0) {
          // Only mark as off-screen when element has been scrolled past (above viewport)
          setIsOnScreen(false)
        }
      },
      { threshold: 0.5 },
    )
  }, [])

  useEffect(() => {
    if (observerRef.current && ref.current) {
      observerRef.current.observe(ref.current)
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect()
      }
    }
  }, [ref])

  return isOnScreen
}
